let isScrolling = false;
let lastPortrait = 0;
let lastLandscape = 0;

const update = value => {
    document.documentElement.style.setProperty('--vh', `${value * 0.01}px`);
};

const setLastValues = () => {
    if (window.innerWidth > window.innerHeight) {
        lastLandscape = window.innerHeight;
    } else {
        lastPortrait = window.innerHeight;
    }
};

const getLastValues = () => {
    if (window.innerWidth > window.innerHeight) {
        return lastLandscape || window.innerHeight;
    }
    return lastPortrait || window.innerHeight;
};

const resize = () => {
    // console.log('resize');
    if (!isScrolling) {
        update(window.innerHeight);
        setLastValues();
    }
};

const orientationchange = () => {
    console.log('orientationchange');
    setTimeout(() => {
        console.log('orientationchange => go');
        // console.log('current: ', { w: window.innerWidth, h: window.innerHeight });
        // console.log('stored: ', { lastLandscape, lastPortrait });
        setTimeout(function() {
            window.scrollTo(0, -100);
        });
        update(getLastValues());
    }, 30);
};

const scroll = () => {
    // console.log('scroll');
    window.clearTimeout(isScrolling);
    isScrolling = setTimeout(() => {
        isScrolling = false;
    }, 60);
};

const init = () => {
    resize();
    window.addEventListener('resize', () => {
        requestAnimationFrame(resize);
    }, { capture: false, passive: true });
    window.addEventListener('orientationchange', () => {
        requestAnimationFrame(orientationchange);
    }, { capture: false, passive: true });
    window.addEventListener('scroll', () => {
        requestAnimationFrame(scroll);
    }, { capture: false, passive: true });
};

export default {
    init
};



// WEBPACK FOOTER //
// ./src/js/components/ViewportHeight.js